import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getDataConnectionList = async () => {
  return axios.get(`${api_base_url}/GetDataConnection`).then((res) => {
    return res;
  });
};

export const addDataConnection = async (newDataConnection) => {
  const { data } = await axios.post(`${api_base_url}/AddDataConnection`, {
    ...newDataConnection,
  });
  return data;
};

export const deleteDataConnection = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateDataConnection`, {
    data: ids,
  });
  return data;
};

export const updateDataConnection = async (editDataConnection) => {
  const { data } = await axios.put(`${api_base_url}/EditDataConnection`, editDataConnection);
  return data;
};
